/**
 * Rótulos das chaves de permissão, e a rota de "acesso negado".
 *
 * O texto é o que a pessoa entende; a chave é interna. Vive num arquivo só
 * porque três telas escrevem a mesma coisa: a de permissões (o que liga e
 * desliga), o histórico (o que mudou) e a de acesso negado (o que faltou).
 * Três cópias do mesmo mapa divergiriam na primeira edição.
 *
 * A tela de acesso negado recebe a CHAVE pela URL, não um texto livre: a
 * chave sobrevive a recarregar a página e ao botão de voltar, é validada
 * contra a lista fechada de `@nv/core`, e o rótulo continua tendo uma fonte só.
 */
import { PERMISSION_KEYS, type PermissionKey } from '@nv/core';

export const ROTULOS_PERMISSAO: Record<PermissionKey, string> = {
  manage_members: 'Gerenciar participantes',
  manage_permissions: 'Gerenciar permissões',
  edit_itinerary: 'Criar e editar atividades',
  reorder_itinerary: 'Reorganizar o roteiro',
  create_expenses: 'Criar despesas',
  edit_others_expenses: 'Editar despesas de outras pessoas',
  manage_places: 'Gerenciar lugares salvos',
  manage_trip_settings: 'Editar configurações da viagem',
  manage_documents: 'Gerenciar documentos',
  manage_family: 'Gerenciar a família',
  export_trip: 'Exportar os dados da viagem',
};

/** "Reorganizar o roteiro" → "reorganizar o roteiro", para caber numa frase. */
export function descricaoDaAcao(chave: PermissionKey | null): string {
  if (!chave) return 'fazer isso';
  const rotulo = ROTULOS_PERMISSAO[chave];
  return rotulo.charAt(0).toLowerCase() + rotulo.slice(1);
}

export function rotaNegado(chave: PermissionKey): string {
  return `/negado?permissao=${encodeURIComponent(chave)}`;
}

/** Só aceita chave que existe. Valor inventado na URL vira "fazer isso". */
export function permissaoDaBusca(valor: string | null): PermissionKey | null {
  if (!valor) return null;
  return (PERMISSION_KEYS as readonly string[]).includes(valor) ? (valor as PermissionKey) : null;
}
